import { useState, useRef, useEffect } from "react";
import "./ProjectSelect.scss";

function ProjectSelect({ value, onChange, label = "По проектам" }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const options = [
    { value: "all", label: "Всем" },
    { value: "retargeo", label: "Ретаргео" },
    { value: "programmatic", label: "Программатик" },
  ];

  const selectedOption = options.find((opt) => opt.value === value) || options[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (optionValue) => {
    setIsOpen(false);
    setTimeout(() => {
      onChange({ target: { value: optionValue } });
    }, 0);
  };

  return (
    <div className="ProjectSelect" ref={dropdownRef}>
      <div className="ProjectSelect-label">{label}</div>
      <div
        className={`ProjectSelect-button ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="ProjectSelect-value">{selectedOption.label}</span>
        <svg
          className="ProjectSelect-arrow"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 4.5L6 7.5L9 4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      {isOpen && (
        <div className="ProjectSelect-dropdown">
          {options.map((option) => (
            <div
              key={option.value}
              className={`ProjectSelect-option ${value === option.value ? "selected" : ""
                }`}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProjectSelect;
